<div
  class="print-cover-page"
  #coverPageElement
  [class.print-cover-page--screen]="showAsScreenPage()"
  [class.d-none]="!coverPageIsReady() && !coverImageUrl() && !showGradient()"
  [ngClass]="coverPageClasses()"
>
  @if (showGradient()) {
    <div class="print-cover-page-gradient"></div>
  } @else {
    <div class="print-cover-page-image">
      <img [src]="coverImageUrl()" alt="Report cover" />
    </div>
  }

  <div class="print-cover-page-title-wrapper">
    <div class="print-cover-page-title">
      <ng-content select="[cover-title]" />
      @if (showDefaultTitle()) {
        <h1 [innerHtml]="reportTitle()"></h1>
        <table>
          <tr>
            <th>{{ 'reportPlus.organisation' | translate }}:</th>
            <td>{{ organizationName() }}</td>
          </tr>
          <tr>
            <th>{{ 'data.date' | translate }}:</th>
            <td>{{ currentDate | date: 'longDate' }}</td>
          </tr>
        </table>
      }
    </div>

    <div class="print-cover-page-title-footer">
      <ng-content select="[cover-logo]" />
      @if (showDefaultLogo()) {
        @if (customLogo()) {
          <img [src]="customLogo()" alt="logo" />
        } @else {
          <img [src]="environment.customerAssetsDir + 'img/' + logo()" alt="Logo" />
          @if (showGreenBuildingsLogoTitleFooter) {
            <img class="ms-2 logo-gbt" src="./assets/img/report/green-buildings-tool.png" alt="Green Buildings Tool" />
          }
        }
      }
    </div>
  </div>

  <ng-content select="[cover-chrome-footer]" />
  @if (showFooter()) {
    <cfp-report-footer [showPoweredBy]="showPoweredBy()" [printOnly]="!showAsScreenPage()">
      <ng-content select="[cover-footer]" />
    </cfp-report-footer>
  }
</div>
